export const TypingIndicator = () => (
  <div
    className="@TypingIndicator flex justify-start"
    role="status"
    aria-label="Typing..."
  >
    <div className="max-w-[80%] rounded-lg bg-neutral/10 p-3">
      <div className="flex items-center gap-1">
        <div
          className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary/50"
          style={{ animationDelay: '0ms' }}
        />
        <div
          className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary/50"
          style={{ animationDelay: '150ms' }}
        />
        <div
          className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary/50"
          style={{ animationDelay: '300ms' }}
        />
      </div>
    </div>
  </div>
);
